module.exports = __webpack_public_path__ + "static/media/icone_bandeira.05eabefb.png";